import { render, staticRenderFns } from "./LineWidthChoice.vue?vue&type=template&id=2223e095&scoped=true&"
import script from "./LineWidthChoice.vue?vue&type=script&lang=js&"
export * from "./LineWidthChoice.vue?vue&type=script&lang=js&"
import style0 from "./LineWidthChoice.vue?vue&type=style&index=0&id=2223e095&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2223e095",
  null
  
)

export default component.exports